import { camelizeKeys } from 'humps';
import { post } from '@namespace/helpers';
import { CasinoTypeUnion, IApiResponse } from '../../../types';

export interface IRealTimeWins {
  limit: number;
  casinoType: CasinoTypeUnion;
}

interface ISingleRealTimeWin {
  amount: string;
  currency: string;
  internal_game_id: number;
  provider_id: number;
  user_id: string;
}

export interface IRealTimeWinsResponse {
  items: ISingleRealTimeWin[];
}

export const realTimeWins = ({
  limit = 15,
  casinoType = 'casino'
}: IRealTimeWins) =>
  post<IApiResponse<IRealTimeWinsResponse>>(
    `/service/suggester-games/suggester/v3/realtime-wins/get-wins`,
    {
      game_list: casinoType,
      limit
    }
  ).then((res) => camelizeKeys<IApiResponse<IRealTimeWinsResponse>>(res));
